import { Popover, PopoverButton, PopoverPanel } from "@headlessui/react";
import { AnchorProps } from "@headlessui/react/dist/internal/floating";
import classNames from "classnames";
import { MouseEvent, ReactNode, useEffect, useRef, useState } from "react";

export const PopoverMenu = ({
  children,
  customMenuItems = undefined,
  className = "",
  menuClassName = "",
  position = "bottom",
  menuExactWidth = false,
  onPopoverClick = () => {},
}: {
  children: ReactNode;
  customMenuItems?:
    | ReactNode
    | ((props: { open: boolean; close: () => void }) => ReactNode);
  className?: string;
  menuClassName?: string;
  position?: AnchorProps;
  menuExactWidth?: boolean;
  onPopoverClick?: (e: MouseEvent<HTMLDivElement>) => void;
}) => {
  const [width, setWidth] = useState(0);

  const containerRef = useRef<HTMLButtonElement | null>(null);

  useEffect(() => {
    if (containerRef.current) {
      setWidth(containerRef.current.offsetWidth);
    }
  }, [containerRef?.current?.offsetWidth]);

  return (
    <>
      <Popover
        className={`relative inline-block text-left !outline-none focus-within:!outline-none focus:!outline-none ${className}`}
        data-open={true}
      >
        {({ open, close }) => {
          return (
            <>
              <PopoverButton
                as={"div"}
                autoFocus={false}
                className="w-full outline-none focus-within:outline-none focus:outline-none"
                ref={containerRef}
                onClick={(e) => {
                  onPopoverClick(e);
                }}
              >
                {children}
              </PopoverButton>

              <PopoverPanel
                className={classNames(
                  `relative z-[900] flex flex-col overflow-x-hidden overflow-y-scroll`,
                  {
                    "rounded-md border bg-white": customMenuItems === undefined,
                    "w-full min-w-max": !menuExactWidth,
                  },
                  "[--anchor-gap:16px]",
                  "outline-none focus-within:outline-none focus:outline-none",
                  menuClassName
                )}
                transition
                anchor={position}
                style={{
                  width: width,
                  minWidth: menuExactWidth ? `${width} !important` : undefined,
                  maxWidth: menuExactWidth ? `${width} !important` : undefined,
                }}
                portal
              >
                {typeof customMenuItems === "function"
                  ? customMenuItems({ open, close })
                  : customMenuItems}
              </PopoverPanel>
            </>
          );
        }}
      </Popover>
    </>
  );
};
